import { useTheme } from "@mui/material";
import { BarElement, BarElementProps, HighlightItemData } from "@mui/x-charts";

import { getUnitUsageColor } from "~/utils/unitUsageHelpers";
import { TotalUsageType } from "./DashboardPPTCharts";

const TotalUsageBar = ({
  totalUsage,
  highlightedAuth,
  ...props
}: BarElementProps & { totalUsage: TotalUsageType; highlightedAuth: HighlightItemData }) => {
  const theme = useTheme();

  if (!totalUsage) {
    return null;
  }

  const hasHighlight = !!highlightedAuth;
  const isThisBarHighlighted = highlightedAuth?.seriesId === totalUsage.authorizationServiceId;
  if (props.id !== "usedUnits") {
    return (
      <BarElement
        {...props}
        {...(isThisBarHighlighted && {
          color: "url(#PatternHighlight)",
          fill: "url(#PatternHighlight)",
        })}
        {...(hasHighlight &&
          !isThisBarHighlighted && {
            color: "url(#PatternFade)",
            fill: "url(#PatternFade)",
          })}
      />
    );
  }

  const rawColor = getUnitUsageColor(totalUsage.unitUsagePercentage, theme);
  const color = typeof rawColor === "function" ? rawColor(theme) : rawColor;

  return (
    <BarElement
      {...props}
      color={color}
      fill={color}
      style={{
        filter: "brightness(1)",
        ...(isThisBarHighlighted && {
          filter: "brightness(150%)",
        }),
        ...(hasHighlight &&
          !isThisBarHighlighted && {
            opacity: "0.3",
          }),
      }}
    />
  );
};

export default TotalUsageBar;
